import { useContext } from "react"
import { LoadingContext } from "src/M_Components"

export default class docTagsService {
    ctx = useContext(LoadingContext)
    containerRequiredKeys = ["prefix", "number", "checkDigit", "nrPackage", "description", "grossWeight", "measurements"]

    varNameDict = new Map()
    varNameArray = [] //* :string[]
    varCategoryDict = new Map()
    shipmentDict = new Map() //* :Map<number,Map<number,Map<string,any>>>
    shipmentCopy = new Map() //* :Map<number,Map<string,any>>

    newShipment = new Map() //* :Map<number,any>

    regexVoyage = /voyage/ //* RegExp
    regexShipper = /shipper/ //* RegExp
    regexNotify = /notify/ //* RegExp
    regexConsignee = /consignee/ //* RegExp
    regexFreight = /freight/ //* RegExp
    regexCargo = /cargo/ //* RegExp
    regexShipping = /shipping/ //* RegExp
    regexArray = [this.regexVoyage, this.regexShipper, this.regexNotify, this.regexConsignee, this.regexFreight, this.regexShipping, this.regexCargo] //* :RegExp[]

    varNameInputArray = ['shipperName', 'shipperAddress', 'shipperAddress2', 'shipperVat', 'shipperZipCode', 'shipperCountry', 'consigneeName', 'consigneeZipCode', 'consigneeCountry', 'consigneeVat', 'consigneeAddress', 'consigneeAddress2', 'notifyName', 'notifyAddress', 'notifyAddress2', 'notifyVat', 'notifyZipCode', 'notifyCountry']

    getVarNameInputArray() {
        return this.varNameInputArray
    }

    getVarNameDict() { //* :Map<string,string>
        return this.varNameDict
    }
    getVarCategoryDict() { //* :Map<string,string[]>
        return this.varCategoryDict
    }
    setVarNameDict(key, value) { //* :void
        //* key:string,
        //* value:string

        this.varNameDict.set(key, value)
    }
    resetShipmentDict() {
        this.shipmentDict.clear()
        this.shippingSection()
    }

    tagRemoval(data) {
        //* data: string
        this.varNameArray = []
        let varName = ''    //* : string
        const regex = /##\w*##/g //* : RegExp
        const regex2 = /#*$/ //* : RegExp
        const regex3 = /#*/ //* : RegExp
        const matches = data.matchAll(regex)

        for (const match of matches) {
            varName = match[0].replace(regex2, '')
            varName = varName.replace(regex3, '')
            this.varNameDict.set(varName, '')
            this.varNameArray.push(varName)
            data = data.replace(match[0], ' ')
            // data = data.replace(match[0], varName)
            // data = data.replace(match[0],"<input #viewer type='text' class='docInput' [(ngModel)]='"+ varName + "'value='' (Change)='InputChange("+varName+")'>")
        }
        this.categoryArrays(this.varNameArray)
        return data
    }

    categoryArrays(data) {
        //* data: string[]

        this.varCategoryDict.set("Shipper", this.iterate(data, this.regexShipper))
        this.varCategoryDict.set("Consignee", this.iterate(data, this.regexConsignee))
        this.varCategoryDict.set("Notify", this.iterate(data, this.regexNotify))
        this.varCategoryDict.set("Voyage", this.iterate(data, this.regexVoyage))
        this.varCategoryDict.set("Freight", this.iterate(data, this.regexFreight))
        this.varCategoryDict.set("Shipping", this.iterate(data, this.regexShipping))
        this.varCategoryDict.set("Cargo", this.iterate(data, this.regexCargo))
    }

    iterate(data, regex) {
        //* data: string[], 
        //* regex: RegExp
        const varCategoryArray = [] //* : string[]
        data.forEach(elem => {

            if (elem.match(regex)) {
                varCategoryArray.push(elem)
            }
        })
        return varCategoryArray
    }

    cleanNames(data) { //* : string
        //* data: string
        this.regexArray.forEach(elem => {
            data = data.replace(elem, '')
        })
        return data
    }

    calculateContainerNr(data, key, isLimited) {
        let nr = 1
        const matriculasArray = []

        data.forEach(obj => {
            // if (`${obj.equipmentType} ${obj.Tare}` === key) {
            if (`${isLimited ? obj.equipmentType : `${obj.equipmentType} ${obj.Tare}`}` === key) {
                if (!matriculasArray.includes(obj.matricula)) {
                    if (obj.matricula !== '') {
                        matriculasArray.push(obj.matricula)
                    }
                }
            }
        })

        return matriculasArray.length || nr
    }

    formatFloat(value) {
        // const newValue = Number.parseFloat(value).toFixed(3)
        if (Number.parseFloat(value)) {
            const newValue = Number.parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 3 })

            if (this.ctx.useComma) {
                return newValue.replace('.', '$#').replaceAll(',', '.').replace('$#', ',')
            } else {
                return newValue
            }
        } else {
            return value
        }
    }

    updateDoc(data, dict, shipDict, bol, page, pageSize, auxPageSize, docSize) {
        //! HERE 
        //* data: string html
        //* dict: dictionary
        if (bol === undefined) return
        if (data === undefined) return
        // console.log('inside')
        let varName = '' //* : string
        let varValue = '' //* : string
        const regex = /##\w*##/g //* : RegExp
        const regex2 = /#*$/ //* : RegExp
        const regex3 = /#*/ //* : RegExp
        const matches = data.matchAll(regex)
        let tempShipmentString
        for (const match of matches) {

            varName = match[0].replace(regex2, '')
            varName = varName.replace(regex3, '')
            if (varName === "shipping") {
                // console.log('teste')
                tempShipmentString = this.shippingSection(shipDict, auxPageSize, docSize, page, bol)

                if (tempShipmentString[1] >= pageSize && page === 1) {

                    varValue = this.shipmentLimited(shipDict)[0]
                } else {
                    varValue = this.getVarNameDict().get(varName) || tempShipmentString[0]
                }
            } else {

                if (bol === true) {
                    if (this.varNameInputArray.includes(varName)) {

                        varValue = '<input style="width:inherit" type="text" id="' + varName.toString().toLocaleUpperCase() + '" value="' + dict.get(varName) + '"/>'
                    } else {

                        // varValue = '<input style="width:inherit" type="text" id="' + varName.toString().toLocaleUpperCase() + '" value="' + dict.get(varName) + '"/>'
                        varValue = dict?.get(varName)?.toString().toLocaleUpperCase() || " "
                    }
                } else {

                    varValue = dict?.get(varName)?.toString().toLocaleUpperCase() || " "
                }
            }
            data = data.replace(match[0], varValue)
        }
        if (!tempShipmentString[1]) return
        return [data, tempShipmentString[1]]
    }

    shipmentLimited(data) {
        let finalString = '' //* : string
        //shippings
        if (!data) return ''
        let totalLines = 0
        const tempMap = new Map()
        let containerIndex = 1

        const tempMatriculas = []
        data.forEach((obj) => {
            let tempObj
            if (!tempMap.get(obj.equipmentType)) {
                tempMap.set(obj.equipmentType, new Map())
            }
            if (tempMatriculas.includes(obj.matricula)) {
                tempObj = { ...obj, matricula: '' }
            } else {
                tempObj = obj
                tempMatriculas.push(obj.matricula)
            }
            tempMap.get(obj.equipmentType).set(containerIndex, tempObj)
            containerIndex = containerIndex + 1
        })

        Object.keys(Object.fromEntries(tempMap)).forEach(() => {
            totalLines = totalLines + 1
        })
        finalString = finalString.concat('<div style="display:flex;position:relative; font-size: 24px; font-weight:bold; font-style:italic; left:460px; margin:20px;">Cargo details as per specification attached</div>')
        finalString = finalString.concat('<div style="display:flex; position:relative; left:460px; margin-top:30px; font-size:18px; font-style:italic;">Continued on next page</div>')
        return [finalString.toLocaleUpperCase(), totalLines]
    }

    shippingSection(data, auxPageSize, docSize, page, bol) {
        let finalString = '' //* : string
        if (!data) return ''

        const tempMap = new Map()
        //* key: containerType + tare; value: Map(key: containerNr, value x ; key containers, value: x Map()):
        //* key: containerNr value: x
        //* key: containers; value: x Map()

        let totalLines = 0
        let containerIndex = 1

        const shipmentArray = []
        // let shipmentCount = 0

        const tempMatriculas = []
        data.forEach((obj) => {
            if (!shipmentArray.includes(obj.shipment)) {
                shipmentArray.push(obj.shipment)
            }

            // console.log(obj.matricula)
            let tempObj
            if (!tempMap.get(`${obj.matricula} ${obj.equipmentType} ${obj.Tare}`)) {
                tempMap.set(`${obj.matricula} ${obj.equipmentType} ${obj.Tare}`, new Map())
            }
            if (tempMatriculas.includes(obj.matricula)) {
                tempObj = { ...obj, matricula: '' }
            } else {
                tempObj = obj
                tempMatriculas.push(obj.matricula)
            }
            tempMap.get(`${obj.matricula} ${obj.equipmentType} ${obj.Tare}`).set(containerIndex, tempObj)
            containerIndex = containerIndex + 1
        })
        // console.log(shipmentArray.length, ' Shipments')
        let startLine = 0
        let breakLine = auxPageSize
        if (page > 1) {
            startLine = auxPageSize * ((page - 1) - 1) + 1
            breakLine = auxPageSize * (page - 1)
        }

        let tempString = ''
        let prevMarks = null
        Object.keys(Object.fromEntries(tempMap)).forEach((key) => {
            totalLines = totalLines + 1
            if (totalLines >= startLine && totalLines <= breakLine) {
                const tare = Object.values(Object.fromEntries(Object.fromEntries(tempMap)[key]))[0].Tare || ''
                tempString = tempString.concat(' <div style="display:flex;position:relative; left:550px; margin:5px; "> ' + this.calculateContainerNr(Object.values(Object.fromEntries(Object.fromEntries(tempMap)[key])), key) + ' X ' + Object.values(Object.fromEntries(Object.fromEntries(tempMap)[key]))[0].equipmentType + ' SAID TO CONTAIN: </div>')
                tempString = tempString.concat(' <div style="display:flex;position:relative; left:1200px; margin:5px; "> ' + ' Tare: ' + this.formatFloat(tare) + '  </div>')
            }
            totalLines = totalLines + 1
            const groupValues = Object.values(Object.fromEntries(Object.fromEntries(tempMap)[key]))
            // Collect in-range values while counting lines
            const inRangeValues = []
            groupValues.forEach((value) => {
                totalLines = totalLines + 1
                if (totalLines >= startLine && totalLines <= breakLine) {
                    inRangeValues.push(value)
                }
            })
            if (inRangeValues.length > 0) {
                // Sub-group by consecutive marks changes within the container
                const subGroups = []
                let currentSubGroup = null
                inRangeValues.forEach((value) => {
                    if (!currentSubGroup || (value.marks && value.marks !== currentSubGroup.marks)) {
                        currentSubGroup = { marks: value.marks || '', values: [] }
                        subGroups.push(currentSubGroup)
                    }
                    currentSubGroup.values.push(value)
                })
                let isFirstSubGroup = true
                subGroups.forEach((subGroup) => {
                    const showMarks = subGroup.marks && subGroup.marks !== prevMarks
                    if (showMarks) prevMarks = subGroup.marks
                    const marksHtml = showMarks
                        ? (bol === true
                            ? '<div style="width:260px; margin-top:4px; overflow:hidden;"><input style="width:260px;" type="text" id="' + subGroup.values[0].id + 'marks' + '" value="' + subGroup.marks + '"/></div>'
                            : '<div style="width:260px; word-break:break-word; overflow-wrap:break-word; margin-top:4px;">' + subGroup.marks + '</div>'
                          )
                        : ''
                    let descHtml = ''
                    subGroup.values.forEach((value) => {
                        if (bol === true) {
                            descHtml = descHtml.concat(
                                '<div style="display:flex; margin-bottom:10px;"><div #cargoDiv style="display:flex; position:relative; left:350px; width:550px;"> <div style="width: 40px; margin-right: 2px;"><input style="width:inherit" type="text" id="' + value.id + 'nrPackage' + '" value="' + value.nrPackage + '"/></div> <div style="width: 450px; margin-left:10px; margin-right: 20px;"> <input style="width:inherit" type="text" id="' + value.id + 'description' + '" value="' + value.description + '"/></div></div><div #propriedadesDiv style="display:flex; position:relative;left:450px; width:200px;"> <div style="width: 100px; "><input style="width:inherit" type="text" id="' + value.id + 'grossWeight' + '" value="' + value.grossWeight + '"/></div><div style="position:relative; left:80px;"><input style="width:inherit" type="text" id="' + value.id + 'measurements' + '" value="' + value.measurements + '"/></div> </div></div>' +
                                '<div style="height:12px; width:1600px;"></div>'
                            )
                        } else {
                            descHtml = descHtml.concat(
                                '<div style="display:flex; margin-bottom:10px;"><div #cargoDiv style="display:flex; position:relative; left:350px; width:550px;"> <div style="width: 40px; margin-right: 2px;">' + value.nrPackage + ' </div> <div style="width: max-content; margin-left:10px; margin-right: 20px;"> ' + value.description + ' </div></div><div #propriedadesDiv style="display:flex; position:relative;left:450px; width:200px;"> <div style="width: 100px; ">' + this.formatFloat(value.grossWeight) + ' </div><div style="position:relative; left:80px;">' + this.formatFloat(value.measurements) + '</div> </div></div>' +
                                '<div style="height:12px; width:1600px;"></div>'
                            )
                        }
                    })
                    const matricula = isFirstSubGroup ? inRangeValues[0].matricula : ''
                    isFirstSubGroup = false
                    tempString = tempString.concat(
                        '<div style="display:flex; width:1600px; align-items:flex-start;">' +
                        '<div style="display:flex; flex-direction:column; width:300px; flex-shrink:0;">' +
                        (matricula ? '<div style="width: 290px; word-break: break-all; overflow-wrap: break-word; margin-right: 3px;"> ' + matricula + ' </div>' : '') +
                        marksHtml +
                        '</div>' +
                        '<div style="display:flex; flex-direction:column; width:1300px;">' +
                        descHtml +
                        '</div>' +
                        '</div>'
                    )
                })
            }
        })

        finalString = tempString
        if (page > 1 && totalLines >= startLine && totalLines <= breakLine) {
            finalString = finalString.concat('<br><div style="display:flex;position:relative; left:460px; margin:5px; font-size:24px !important;font-family:monospace;text-align: left;font-weight: bold; font-style: italic; letter-spacing: 1px;"><div style="color: rgba(0, 0, 0, 1);width: 100px;height: 21px;left: 100px;top: 210px;border-bottom: 4px dotted;"></div>End of Attached List to Bill of Lading<div style="color: rgba(0, 0, 0, 1);width: 100px;height: 21px;left: 100px;top: 210px;border-bottom: 4px dotted;"></div></div')
        }
        // console.log(totalLines)
        return [finalString, totalLines]
    }

}
